import axios from 'axios'

const API_PATH = 'api/v2/admins/administrators'

const AdministratorsApiV2 = {
  get: ({ q = '', role = 'all', active = '' } = {}) => axios.get(API_PATH, {
    params: {
      ...(q ? { q } : {}),
      ...(role && role !== 'all' ? { role } : {}),
      ...(active !== '' ? { active } : {})
    }
  }),
  show: (id) => axios.get(`${API_PATH}/${id}`),
  create: (values) => axios.post(API_PATH, { administrator: values }),
  update: (id, values) => axios.patch(`${API_PATH}/${id}`, { administrator: values }),
  destroy: (id) => axios.delete(`${API_PATH}/${id}`),
  export: ({ format, q = '', role = 'all', active = '' }) => axios.get(`${API_PATH}/export`, {
    params: {
      format,
      ...(q ? { q } : {}),
      ...(role && role !== 'all' ? { role } : {}),
      ...(active !== '' ? { active } : {})
    },
    responseType: 'blob'
  })
}

export default AdministratorsApiV2
